export default "__VITE_ASSET__01e680af__"